<template>
  <span>
    <mu-avatar class="imageBadge" :size="34" v-if="mode === 'image'" :src="badge.image"
               v-tooltip.left="badge.label"></mu-avatar>
    <mu-badge v-if="mode === 'text'" class="userBadge" :content="badge.label" :class="badge.key"/>
  </span>
</template>
<script>
  import _ from "lodash"

  export default {
    props: {
      type: {
        type: String,
      },
      mode: {
        type: String,
        default: 'text'
      }
    },
    name: 'user-badge',
    data() {
      return {
        badges: [
          {
            key: "support",
            label: this.$t('message.badgeSupport'),
            image: 'static/badges/low-carb-support-team.svg'
          },
          {
            key: "champion",
            label: this.$t('message.badgeChampion'),
            image: "static/badges/champion.svg"
          },
          {
            key: "finished-program",
            label: this.$t('message.badgeCompleted'),
            image: "static/badges/completed-program-100.svg"
          },
          {
            key: "hcp-verified",
            label: "HCP Verified",
            image: "static/badges/completed-program-100.svg"
          },
        ],
        badge: {}
      }
    },
    mounted() {
      let self = this;
      let badge = _.findKey(self.badges, ['key', self.type]);
      self.badge = self.badges[badge];
    }
  }
</script>

<style lang="less">

  .imageBadge {
    img {
      box-shadow: none !important;
    }
  }
  .userBadge {

    margin: 0 4px 0 0;
    .mu-badge {
      white-space: nowrap;
      color: #FFFFFF;
      border-radius: 100px;
      padding: 2px 12px;
      font-size: .9rem;
    }
    &.support {
      .mu-badge {
        background-color: #0179d5 !important;
      }
    }
    &.champion, &.hcp-verified {
      .mu-badge {
        background-color: #f6bf16 !important;
      }
    }
    &.finished-program {
      .mu-badge {
        background-color: #008a00 !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// UserBadge.vue?020ff3dd